import _asyncToGenerator from "@babel/runtime/helpers/esm/asyncToGenerator";
import _regeneratorRuntime from "@babel/runtime/regenerator";
import React from "react";
import Panel from "./Panel";

var rehydrator = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(domNode, rehydrateChildren) {
    var props, childrenNode, reactifiedChildren;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            props = {
              id: domNode.getAttribute("id"),
              isRehydrating: true,
              tabTitle: domNode.getAttribute("data-tab-title")
            };
            childrenNode = domNode.querySelector("[data-rehydratable-children]");
            _context.next = 4;
            return rehydrateChildren(childrenNode);

          case 4:
            reactifiedChildren = _context.sent;
            return _context.abrupt("return", /*#__PURE__*/React.createElement(Panel, props, reactifiedChildren));

          case 6:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));

  return function rehydrator(_x, _x2) {
    return _ref.apply(this, arguments);
  };
}();

export default rehydrator;